















































import Vue from "vue";
import DeleteButton from "./../interface/DeleteButton.vue";
export default Vue.extend({
  name: "file-upload",
  props: {
    uploadPercentage: {
      type: Number,
      default: null,
    },
    label: {
      type: String,
    },
    noMultiple: {
      type: Boolean,
      default: false,
    },
    acceptedFileTypes: {
      type: String,
      default: ".pdf,.jpg,.jpeg,.png,.txt,.docx"
    }
  },
  components: { DeleteButton },
  data() {
    return {
      bestanden: [] as File[],
    };
  },
  methods: {
    onFileSelected(e: Event): void {
      let fileList = (e.target as HTMLInputElement).files;
      if (fileList) {
        if (this.noMultiple) {
          this.bestanden = Array.from(fileList);
        } else {
          Array.from(fileList).forEach((file) => {
            this.bestanden.push(file);
          });
        }
      }
      this.emitChangedFiles();
    },
    deleteFile(index: number): void {
      this.bestanden.splice(index, 1);
      this.emitChangedFiles();
    },
    emitChangedFiles(): void {
      if (this.noMultiple) {
        this.$emit("files-changed", this.bestanden[0]);
      } else {
        this.$emit("files-changed", this.bestanden);
      }
    },
  },
});
